/**
 * Forgot password page — email form, POST to Flask.
 *
 * Flask always flashes the same message whether the account exists or not
 * (email enumeration prevention). The flash arrives as ?success on redirect.
 */
import { useState } from 'react'
import { API_BASE } from '../../lib/api'
import './auth.css'

export default function ForgotPassword() {
  const successParam = new URLSearchParams(window.location.search).get('success')
  const [submitted] = useState(!!successParam)

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">Priori</div>
        <h1 className="auth-title">Reset password</h1>
        <p className="auth-sub">
          Enter your email and we'll send you reset instructions.
        </p>

        {submitted && (
          <div className="auth-flash auth-flash--success">
            If an account exists with that email, you will receive
            password reset instructions.
          </div>
        )}

        <form action={`${API_BASE}/auth/forgot-password`} method="POST">
          <label className="auth-field">
            <span className="auth-label">Email</span>
            <input className="auth-input" name="email" type="email"
                   placeholder="you@club.com" required autoComplete="email" />
          </label>
          <button className="auth-btn auth-btn--primary" type="submit">
            Send reset link
          </button>
        </form>

        <div className="auth-links">
          <a href="/login">Back to sign in</a>
        </div>
      </div>
    </div>
  )
}
